type LogLevel = "debug" | "info" | "warn" | "error";

const isProd = import.meta.env.PROD;
const logsEnabled =
  import.meta.env.VITE_ENABLE_LOGS === "true" ||
  import.meta.env.VITE_ENABLE_DEBUG_LOGS === "true";

const shouldLog = (level: LogLevel) => {
  // By default, suppress all logs in production unless explicitly enabled.
  if (isProd && !logsEnabled) return false;
  // Extra safeguard: drop debug in prod even if logsEnabled is mis-set.
  if (isProd && level === "debug") return false;
  return true;
};

const log = (
  level: LogLevel,
  namespace: string,
  message: string,
  ...args: unknown[]
) => {
  if (!shouldLog(level)) return;

  const prefix = `[${namespace}]`;
  const payload = [`${prefix} ${message}`, ...args];

  switch (level) {
    case "debug":
    case "info":
      console.log(...payload);
      break;
    case "warn":
      console.warn(...payload);
      break;
    case "error":
      console.error(...payload);
      break;
    default:
      console.log(...payload);
  }
};

export const createLogger = (namespace: string) => ({
  debug: (message: string, ...args: unknown[]) =>
    log("debug", namespace, message, ...args),
  info: (message: string, ...args: unknown[]) =>
    log("info", namespace, message, ...args),
  warn: (message: string, ...args: unknown[]) =>
    log("warn", namespace, message, ...args),
  error: (message: string, ...args: unknown[]) =>
    log("error", namespace, message, ...args),
});
